import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { DefaultErrorRoute } from '~/core/DefaultErrorRoute';
import { Route as DataPipelineListRoute } from '~/core/routes/data-pipeline/_index';
import { Route as DataPipelineDetailsRoute } from '~/core/routes/data-pipeline/details/[meshId]/_index';

/**
 * Data pipeline routes for backup-servicing (BUS) users.
 *
 * BUS users are contained within their own sub-routers and do not reach the
 * shared RR7 `/data-pipeline/*` route (which is gated behind the
 * `productsDataPipelinePermissions` flag). We mount the same list/details
 * views here so the "Data Pipeline" nav item works from inside the BUS portal.
 * The underlying views derive their organization from the logged-in user and
 * need no credit facility, so they work for facility-less BUS implementations.
 */
export const BackupDataPipelineRoutes = (): React.ReactElement => {
  return (
    <RouteErrorBoundary
      resetAfterCatch={false}
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <DefaultErrorRoute />;
      }}
    >
      <Routes>
        <Route path="/" element={<DataPipelineListRoute />} />
        <Route path="/details/:meshId" element={<DataPipelineDetailsRoute />} />
        <Route path="/*" element={<Navigate to="." replace />} />
      </Routes>
    </RouteErrorBoundary>
  );
};
